
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon - Add / 16"}},[_c('path',{attrs:{"data-name":"Intersection 1","d":"M4.5 9.5v-4h-4v-1h4v-4h1v4h4v1h-4v4z","fill":"#1477bc","stroke":"#1477bc"}})])])
          )
        }
      }
    